import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Project } from 'app/interfaces/project.model';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { AuthService } from 'app/modules/auth/services/auth.service';

@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.scss'],
})
export class ProjectDetailComponent implements OnInit, OnDestroy {
  project: any;
  detailsActive = false;
  activeImage: string;
  images = [];
  tab1Active = false;
  tab2Active = false;
  tab3Active = false;
  tab4Active = false;
  group1Active = false;
  groupedImages: Array<any>;
  phaseLookup = ['None', 'Competition', 'Design', 'In progress', 'On site', 'Realized'];
  backUrl = { url: '/projects', text: 'Back to projects' };
  $isAdmin: Observable<boolean>;

  get certificates() {
    const certs = [
      {
        name: 'BREAAM',
        levels: ['none', 'pass', 'good', 'very good', 'excellent', 'outstanding'],
        level: 0,
        value: 'none',
      },
      {
        name: 'LEED',
        levels: ['none', 'silver', 'gold', 'platinum'],
        level: 0,
        value: 'none',
      },
      {
        name: 'WELL',
        levels: ['none', 'silver', 'gold', 'platinum'],
        level: 0,
        value: 'none',
      },
      {
        name: 'DGNB',
        levels: ['none', 'bronze', 'silver', 'gold', 'platinum'],
        level: 0,
        value: 'none',
      },
      {
        name: 'HQE',
        levels: ['none', 'pass', 'good', 'very good', 'excellent', 'exceptional'],
        level: 0,
        value: 'none',
      },
      {
        name: 'GREENSTAR',
        levels: ['none', 'one star', 'two star', 'three star'],
        level: 0,
        value: 'none',
      },
    ].map(a => ({
      ...a,
      level: a.levels.indexOf(this.project['Certificate_' + a.name]?.toLowerCase() || 'none'),
      value: this.project['Certificate_' + a.name] || 'none',
    }));

    return certs;
  }

  get selectedSDGs() {
    return this.project?.SDGs.map(a => a.Name);
  }

  activeTab = 0;
  hidePanels = [];

  sdgGoalNumbers = [...Array(17).keys()];

  constructor(private router: Router, private route: ActivatedRoute, private auth: AuthService) {}

  ngOnInit() {
    this.$isAdmin = this.auth.inRoles('administrator', 'archive-editor');

    this.route.data.subscribe(a => {
      if (a) {
        this.project = a.project;
        this.activeImage = this.project.MainImage;

        this.project.Files.forEach(element => {
          element.orientation = 0;
          element.active = 0;
          this.images.push(element);
        });

        const previousUrl = localStorage.getItem('previousUrl');
        if (previousUrl.startsWith('/page') || previousUrl.startsWith('/projects/page')) {
          this.backUrl.url = previousUrl;
          if (previousUrl.startsWith('/page')) {
            this.backUrl.text = 'Back to home';
          }
        }

        this.groupedImages = _.chain(this.images)
          .groupBy('Category')
          .map((b, c) => {
            return { category: c, items: b };
          })
          .value();
      }
    });

    if (localStorage.getItem('projectTab')) {
      const tab = localStorage.getItem('projectTab');
      this.activeTab = +tab;
      localStorage.removeItem('projectTab');
    }

    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.tab) {
        this.activeTab = +queryParams.tab;

        //
      }
    });
  }

  objArrayToString(objects: Array<any>) {
    if (!objects || objects.length === 0) {
      return '';
    }
    return objects.map(a => a.Name || a.Title).join(', ');
  }

  imageLoaded(image, event) {
    const w = event.path[0].width;
    const h = event.path[0].height;

    if (w > h) {
      image.orientation = 'LANDSCAPE';
    }
    if (w <= h) {
      image.orientation = 'PORTRAIT';
    }
  }

  switchTab(i: number) {
    this.activeTab = i;
    this.hidePanels = [];
  }

  togglePanel(title: string) {
    if (this.hidePanels.indexOf(title) > -1) {
      this.hidePanels = this.hidePanels.filter(a => a !== title);
    } else {
      this.hidePanels.push(title);
    }
  }

  ngOnDestroy() {
    // localStorage.setItem('previousUrl', window.location.origin + window.location.pathname);
  }
}
